const profile=[
     {
         id:"1",
         type:"text",
         name:"First Name",
     },
     {
        id:"2",
        type:"text",
        name:"Last Name",
     },
     {
        id:"3",
        type:"email",
        name:"Email",
     },
     {
        id:"4",
        type:"text",
        name:"Profession",
     }
]

export default profile;